'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import * as React from 'react'
import { ImLinkedin } from 'react-icons/im'

import useLocale from '@/hooks/use-locale'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

const Badge = dynamic(() => import('@/components/ui/badge').then(mod => mod.Badge), {
  ssr: false,
})

interface InstructorCardProps {
  username: string
  position: string
  description: string
  avatar: string
  transform: string
  linkedin: string
  course: string
}

export default function InstructorCard({
  avatar,
  description,
  position,
  username,
  transform,
  linkedin,
  course,
}: InstructorCardProps) {
  const { text } = useLocale()
  return (
    <Card className="rounded-sm border-none bg-accent/65 text-center shadow-none lg:pb-3">
      <CardHeader className="flex w-full items-center justify-center pb-2">
        <Avatar className="mb-4 size-24">
          <AvatarImage src={avatar} alt={username} style={{ transform }} className="object-cover" />
          <AvatarFallback>{username}</AvatarFallback>
        </Avatar>
        <CardTitle className="text-xl">
          <div className="flex space-x-3 items-center">
            <p>{username}</p>
            <Link href={linkedin} rel="noopener noreferrer" target="_blank" aria-label="Visit linkedin profile">
              <ImLinkedin className="text-gray-500 size-5" />
            </Link>
          </div>
        </CardTitle>
        <CardDescription className="text-base text-primary">
          <strong>{position}</strong>
        </CardDescription>
        <CardDescription className="text-base">
          <Badge variant="outline" className="text-sm border-gray-400/65 text-muted-foreground">
            {text.MAIN.INSTRUCTORS.JOB_TITLE} {course}
          </Badge>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">{description}</p>
      </CardContent>
    </Card>
  )
}
